// 提取 {...} 中包含 \over 的内容
export default function extractOverContent(str) {
  const stack = []; // 栈，用于匹配嵌套 {}
  let currentStart = -1; // 当前 { 的起始位置
  const results = []; // 存储匹配结果

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === '{') {
      stack.push(i); // 记录 { 的位置
      if (currentStart === -1) {
        currentStart = i; // 记录最外层 { 的起始位置
      }
    } else if (char === '}') {
      if (stack.length === 0) continue; // 没有匹配的 {，跳过

      const start = stack.pop(); // 取出最近的 { 的位置
      if (stack.length === 0 && currentStart !== -1) {
        // 如果栈为空，说明当前 } 匹配最外层的 {
        const content = str.slice(start + 1, i); // 提取 {} 内的内容
        if (content.includes('\\over')) { // 检查是否包含 \over
          results.push(content);
        }
        currentStart = -1; // 重置起始位置
      }
    }
  }

  return results;
}